import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home"
import { Projects } from "./pages/Projects"
import { LeadCapture } from "./pages/LeadCapture"
import { ThankYou } from "./pages/ThankYou"
import { Blog } from "./pages/Blog"
import { BlogPost } from "./pages/BlogPost"
import { DiagnosticRoute } from "./pages/DiagnosticRoute"
import { PrivacyPolicy } from "./pages/PrivacyPolicy"
import { Analytics } from "@vercel/analytics/react";
import { capturePartnerCode } from "./utils/partnerCode";

function AppRouter() {
  useEffect(() => {
    capturePartnerCode();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Home/>} />
          <Route path="/diagnostico/:slug" exact element={<DiagnosticRoute/>} />
          <Route path="/servicos/:slug" exact element={<DiagnosticRoute/>} />
          <Route path="/captacao" exact element={<LeadCapture/>} />
          <Route path="/campanha-google-ads" exact element={<LeadCapture/>} />
          <Route path="/obrigado" exact element={<ThankYou/>} />
          <Route path="/captacao/obrigado" exact element={<ThankYou/>} />
          <Route path="/cases" exact element={<Projects/>} />
          <Route path="/cases-de-sucesso" exact element={<Projects/>} />
          <Route path="/projetos" exact element={<Projects/>} />
          <Route path="/blog" exact element={<Blog/>} />
          <Route path="/blog/:slug" exact element={<BlogPost/>} />
          <Route path="/privacidade" exact element={<PrivacyPolicy/>} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </>
  );
}

export default AppRouter;
